import { render, staticRenderFns } from "./step_7.vue?vue&type=template&id=28fae027&scoped=true&lang=pug&"
import script from "./step_7.vue?vue&type=script&lang=js&"
export * from "./step_7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fae027",
  null
  
)

export default component.exports